<template>
  <b-card>

    <b-row>

      <!-- User Info: Left col -->
      <b-col
        cols="21"
        xl="6"
        class="d-flex justify-content-between flex-column"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar
            :src="userData.avatar"
            :text="avatarText(userData.fullName)"
            :variant="`light-primary`"
            size="104px"
            rounded
          />
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ userData.civilite }} {{ userData.fullName }}
              </h4>
              <p class="card-text mb-0"  v-if="userData.email">{{ userData.email }}</p>
              <p class="card-text mb-0"  v-if="userData.adress">{{ userData.adress }}</p>
              <p class="card-text mb-0"  v-if="userData.phone">{{ userData.phone }}</p>
              <p class="card-text mb-0"  v-if="userData.company">{{ userData.company }}</p>
              <p class="card-text mb-0"  v-if="userData.structure_client">{{ userData.structure_client }}</p>
              <p class="card-text mb-0"  v-if="userData.function_client">{{ userData.function_client }}</p>
            </div>
          </div>
        </div>

        <!-- User Stats -->
        <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar
              :variant="`light-${resolveUserStatusVariant(userData.status)}`"
              rounded
            >
              <feather-icon
                icon="DollarSignIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
              {{ userData.status }}
              </h5>
              <small>Transaction status | {{ userData.montant }} F</small>
            </div>
          </div>
        </div>
      </b-col>

      <b-col
        cols="12"
        xl="6"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
             <!-- v-if="userData?.numberPiece" -->
            <th class="pb-50">
              <feather-icon
                icon="InfoIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Numéro de piéce d'identité</span>
            </th>
            <td class="pb-50">
              {{ userData.numberPiece }}
            </td>
          </tr>
          <tr >
            <!-- v-if="userData?.country" -->
            <th class="pb-50">
              <feather-icon
                icon="InfoIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Pays de résidence</span>
            </th>
            <td class="pb-50">
              {{ userData.country }}
            </td>
          </tr>

          <tr  >
             <!-- v-if="userData?.arriveContry" -->
            <th class="pb-50">
              <feather-icon
                icon="InfoIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Pays de destination</span>
            </th>
            <td class="pb-50">
              {{ userData.arriveContry }}
            </td>
          </tr>

          <tr>
            <th class="pb-50">
              <feather-icon
                icon="InfoIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Ville de destination</span>
            </th>
            <td class="pb-50">
              {{ userData.arriveVille }}
            </td>
          </tr>

          <tr>
            <th>
              <feather-icon
                icon="InfoIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Position actuelle</span>
            </th>
            <td>
              {{ userData.currentLocation }}
            </td>
          </tr>

            <tr>
            <th>
              <feather-icon
                icon="InfoIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Réservation hôtel</span>
            </th>
            <td>
              {{ userData.bookingHotel }}
            </td>
          </tr>
          
         
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import router from '@/router'
import useTransactionsList from './useTransactionsList'
export default {
  components: {
    BCard, BButton, BRow, BCol, BAvatar,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    }
  },
  setup(props) {
    if (props.userData == null || typeof props.userData == "undefined") {
      router.go(-1)
    } 

     const {

      // UI
      resolveUserStatusVariant,
    } = useTransactionsList()

    return {
      resolveUserStatusVariant,
      avatarText,
    }
  },
}
</script>

<style>

</style>
